/**
 * Centralized feature flags.
 *
 * Toggle a flag to false to hide the feature from the entire UI in one place.
 * Routes referenced by hidden features should redirect to a safe public page.
 *
 * NOTE: Hiding here only hides the UI surface. The backend endpoints
 * (e.g. /api/payments/checkout with plan=founders, /api/founders-slots)
 * remain accessible — that is intentional so direct payment links and
 * internal admin tools keep working.
 */

// Founders Program (€390 — 0,01% equity). Hidden from navigation, footer,
// pricing comparator and landing bridge. Direct URLs /founders-program and
// /programa-fundadores redirect to /plans while the flag is false.
export const SHOW_FOUNDERS_PROGRAM = false;
